import {
  IconSparkles,
  IndigoIndigo60,
  Link,
  Popover,
  Primary13Regular,
  Box
} from '@sequencehq/core-components'
import { UploadAssetButton } from 'Assets/index'
import { useContractUpload } from './useContractUpload'
import {
  ACCEPT_CONTRACT_MIME_TYPE,
  MAX_CONTRACTS_PER_UPLOAD
} from './constants'
import { useIsAutomationActive } from 'Automations/hooks/useIsAutomationActive'
import { automationsPaths } from 'Automations/router'

export const ContractUploadButton = () => {
  const {
    onFilesPicked,
    onUploadSuccess,
    onUploadFailure,
    onAllUploadsComplete
  } = useContractUpload()

  const { isActive: isAutomationActive, isPending: isAutomationPending } =
    useIsAutomationActive({
      triggerType: 'CONTRACT_UPLOADED'
    })

  return (
    <Popover
      isDisabled={isAutomationActive || isAutomationPending}
      trigger="hover"
      content={
        <Box {...Primary13Regular}>
          <Link.Unstyled
            to={automationsPaths.automationsList()}
            style={{ color: IndigoIndigo60 }}
          >
            Set up a contract intake automation
          </Link.Unstyled>{' '}
          to start uploading contracts.
        </Box>
      }
    >
      <UploadAssetButton
        data-testid="billingSchedules.uploadContract"
        variant="secondary"
        leadingIcon={<IconSparkles />}
        disabled={!isAutomationActive}
        onFilesPicked={onFilesPicked}
        onUploadSuccess={onUploadSuccess}
        onUploadFailure={onUploadFailure}
        onAllUploadsComplete={onAllUploadsComplete}
        accept={ACCEPT_CONTRACT_MIME_TYPE}
        multiple
        maximumNumberOfFiles={MAX_CONTRACTS_PER_UPLOAD}
      >
        Upload contracts
      </UploadAssetButton>
    </Popover>
  )
}
